import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { ConnectedService, PlatformService, UserService } from '../services';

export const AuthInterceptor: HttpInterceptorFn = (req, next) => {
  const connectedService = inject(ConnectedService);
  const platformService = inject(PlatformService);
  const userService = inject(UserService);

  if (
    platformService.isBrowser() &&
    window?.sessionStorage &&
    window?.localStorage
  ) {
    const accessToken =
      sessionStorage.getItem('accessToken') ??
      localStorage.getItem('accessToken');
    const customerId = userService.userInfo()?.customerId || 'noCustomerId';

    // we don't wat to use the local storage token for portal requests
    if (accessToken && !req.url.includes('portal/graphql')) {
      connectedService.isLoggedIn.next(true);
      const cloned = req.clone({
        withCredentials: true,
        setHeaders: {
          Authorization: `Bearer: ${accessToken}`,
          customerId,
        },
      });
      return next(cloned);
    }
  }
  return next(req);
};
